
























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {validationMessages} from 'vuelidate-messages';
import {validationMixin} from 'vuelidate';
import Form from './Form';
import Consent from './Consent'
import ConsentsProvider from './ConsentsProvider'
import FormField from "./components/FormField.vue";
import Checkbox from "./components/Checkbox.vue";
import {unwrap} from "./directives/unwrap";
import * as Validators from "./validators";
import generateRandomID from "./generateRandomID";

type FormBuilderValidation = {
    formValues: any;
    consentsValues: any;
}

@Component({
    components: {FormField, VCheckbox: Checkbox},
    mixins: [validationMixin],
    directives: {unwrap},
    validations() {
        const self = this as FormBuilder;

        const validations = self.fields.reduce((acc: FormBuilderValidation, field: any) => {
            acc.formValues[field.name] = field.validations;
            return acc;
        }, {
            formValues: {},
            consentsValues: {}
        })

        self.consents.forEach((consent: any) => {
            validations.consentsValues[consent.consentID] = {};
            if (consent.isRequired) {
                validations.consentsValues[consent.consentID].checked = Validators.checked
            }
        })

        return validations;
    }
})
export default class FormBuilder extends Vue {
    @Prop() readonly form!: Form;
    formValues: { [key: string]: any } = {};
    consentsValues: { [key: number]: boolean } = {};
    consents: Consent[] = [];
    validationMessage: any = () => ([]);
    generateRandomID = generateRandomID;

    async created() {
        this.formValues = this.prepareFormValues(this.fields);
        // @ts-ignore
        this.consents = await new ConsentsProvider(this.form.options.consents.application, this.$i18n.locale).fetchConsents();
        this.consentsValues = this.prepareConsentsValues(this.consents);
        this.validationMessage = validationMessages(this.form.options.validationMessages, {dirty: true, first: 1});
    }

    public validate() {
        // @ts-ignore
        this.$v.$touch();
        // @ts-ignore
        return !this.$v.$error;
    }

    public getData() {
        const values = {...this.formValues, consents: this.prepareConsentsStringValue()};

        return values;
    }

    public reset() {
        this.formValues = Object.entries(this.formValues).map(value => "");
        // @ts-ignore
        this.$v.$reset();
    }

    get fields() {
        return this.form?.fields ?? [];
    }

    private prepareFormValues(fields: any[]) {
        return fields.reduce((acc, field) => {
            acc[field.name] = field.default ? field.default : "";

            return acc;
        }, {})
    }

    private prepareConsentsValues(consents: any[]) {
        return consents.reduce((acc, consent) => {
            acc[consent.consentID] = false;

            return acc;
        }, {})
    }

    private prepareConsentsStringValue() {
        const values = this.consents.reduce((acc: any, consent: any) => {
            acc[consent.consentID] = consent.ID;

            return acc;
        }, {})

        return JSON.stringify(values);
    }
}
